// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"97e87d50","920":"11302bbb"}[chunkId] + ".chunk.css";
};